export const GET_ALL_EMPLOYEES = 'GET_ALL_EMPLOYEES'
export const GET_SINGLE_EMPLOYEE = 'GET_SINGLE_EMPLOYEE'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const CLEAR_RESPONSE_SINGLE_EMPLOYEE = 'CLEAR_RESPONSE_SINGLE_EMPLOYEE'
